<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/Listing.vue";

export default {
  name: "MobileStocksListing",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "État de stock",
    };
  },
};
</script>
